import React from "react";
import PDFContainer from '../../Containers/PDFContainer';


export const AddPDF = (props) => {
	return (
		<PDFContainer page="pdCreate"/>
	);
}

export default AddPDF;